import { render, staticRenderFns } from "./EditDriverGroup.vue?vue&type=template&id=3cc6ec6b&"
import script from "./EditDriverGroup.vue?vue&type=script&lang=js&"
export * from "./EditDriverGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports